import { render, staticRenderFns } from "./OrganizacionaStruktura.vue?vue&type=template&id=7ffc2c82&scoped=true&"
import script from "./OrganizacionaStruktura.vue?vue&type=script&lang=ts&"
export * from "./OrganizacionaStruktura.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc2c82",
  null
  
)

export default component.exports